import React from 'react';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';

import { ChangeEmailForm } from './ChengeEmailForm';
import { ChangeEmailSuccess } from './ChangeEmailSuccess';
import { useChangeEmailHook } from './logic/useChangeEmail';

export interface ChangeEmailProps {
  onClose: () => void;
}

export const ChangeEmail = ({ onClose }: ChangeEmailProps) => {
  const {
    newEmail,
    errorMessage,
    isLoading,
    onSubmit,
    onEmailInputChanged,
    isSuccess,
    onBlur,
    isValid,
    onFinish,
    isLoadingLogOut,
  } = useChangeEmailHook({ onClose });

  return (
    <>
      {isSuccess && <ChangeEmailSuccess newEmail={newEmail} onSubmit={onFinish} isLoadingLogOut={isLoadingLogOut} />}

      {!isSuccess && (
        <UserMessage id='change-email-modal' onClick={onClose} shouldPersist shouldBlur>
          <ChangeEmailForm
            onClose={onClose}
            onEmailChanged={onEmailInputChanged}
            newEmail={newEmail}
            errorMessage={errorMessage}
            isLoading={isLoading}
            onSubmit={onSubmit}
            onBlur={onBlur}
            isValid={isValid}
          />
        </UserMessage>
      )}
    </>
  );
};
